import React from 'react';
import { Chip } from '@mui/material';
import { ComplianceStatus } from '@services/types/api';

interface Props {
  status: ComplianceStatus;
}

const ComplianceStatusChip = ({ status }: Props) => {
  const chipStyles = {
    '& .MuiChip-label': {
      fontSize: '9px',
      padding: '0 6px',
    },
    height: 'auto',
    minHeight: '16px',
  };

  switch (status) {
    case ComplianceStatus.Compliant:
      return (
        <Chip label="Compliant" color="success" variant="filled" size="small" sx={chipStyles} />
      );
    case ComplianceStatus.NonCompliant:
      return (
        <Chip label="Non-Compliant" color="error" variant="filled" size="small" sx={chipStyles} />
      );
    default:
      return status;
  }
};

export default React.memo(ComplianceStatusChip);
